import { render, staticRenderFns } from "./Title2Logo.vue?vue&type=template&id=0cb79e80&scoped=true&"
import script from "./Title2Logo.vue?vue&type=script&lang=js&"
export * from "./Title2Logo.vue?vue&type=script&lang=js&"
import style0 from "./Title2Logo.vue?vue&type=style&index=0&id=0cb79e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb79e80",
  null
  
)

export default component.exports